export default "__VITE_ASSET__C0_ufS3q__"